import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLotteryToken } from '../../Components/lottery/LotteryTokenProvider';
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const LotteryLogin = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const { login } = useLotteryToken();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const response = await axios.post(`${BASE_URL}/happypay/campaigns/happy-pay-cust.php/lottery/login`, {
                username,
                password
            });

            const data = response.data;

            // Login with token and role
            login(data.token, data.role);

            if (data.role === 'admin') {
                navigate('/happypaylottery/admin');
            } else {
                navigate('/happypaylottery');
            }
        } catch (err) {
            if (err.response) {
                // Server responded with error status
                setError(err.response.data.message || 'Нэвтрэх нэр эсвэл нууц үг буруу байна');
            } else if (err.request) {
                // Request made but no response
                setError('Сервертэй холбогдох боломжгүй байна');
            } else {
                // Other errors
                setError('Алдаа гарлаа. Дахин оролдоно уу.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-500 via-purple-500 to-pink-500">
            <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md">
                {/* Logo/Header */}
                <div className="text-center mb-8">
                    <h1 className="text-3xl font-bold text-gray-800 mb-2">
                        Нэвтрэх
                    </h1>
                </div>

                {/* Error Message */}
                {error && (
                    <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                        {error}
                    </div>
                )}

                {/* Login Form */}
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label className="block text-gray-700 font-medium mb-2">
                            Нэвтрэх нэр
                        </label>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                            placeholder="Нэвтрэх нэр"
                            required
                        />
                    </div>

                    <div>
                        <label className="block text-gray-700 font-medium mb-2">
                            Нууц үг
                        </label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                            placeholder="Нууц үг"
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-gradient-to-r from-purple-500 to-pink-500 text-white font-bold py-3 rounded-lg hover:from-purple-600 hover:to-pink-600 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {loading ? 'Нэвтэрч байна...' : 'Нэвтрэх'}
                    </button>
                </form>

                {/* Footer */}
                <div className="mt-6 text-center text-gray-600 text-sm">
                    <p>Happy Pay Lottery System</p>
                </div>
            </div>
        </div>
    );
};

export default LotteryLogin;